// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"e26e1c25","220":"e26e1c25"}[chunkId] + ".chunk.css";
};